export default {
  PATCH: {
    url: '/authentications/user',
    method: 'PUT',
    isPublic: false
  },
  INFO: {
    url: '/authentications/user/getUserInfo/',
    method: 'GET',
    isPublic: false
  }
}
